module.exports = __webpack_public_path__ + "static/media/info-appcode.fac8ea63.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-appcode.gif
// module id = 1744
// module chunks = 0